import React from "react";
import "../App.css";
import {
  FaInstagram,
  FaFacebook,
  FaSoundcloud,
  FaTwitter,
} from "react-icons/fa";
// Test.
import DualitiesImage from "../images/dualities3.jpg";

function Dualities() {
  return (
    <div>
      <div className="flex__layout">
        <div className="artist__description" data-aos="fade-down">
          <h1>Dualities</h1>
          <br />
          <h3>Producers / Songwriters / Artists</h3>
          <br />
          <p>
            Dualities is a duo made up of Simone Guida and Domenico Messina.
            Both born in 1995, they founded the project in 2018. The Italian
            duo, thanks to their fresh and summery sound, have given a serious
            imprint on the Dance/Pop scene in a very short time.
          </p>
          <br />
          <p>
            In November 2018 they released their first single 'No One Like You',
            reaching 2 million streams on Spotify and quickly increasing their
            fanbase.
          </p>
          <br />
          <p>
            The owner of the Loudkult label, Lucas Estrada, which boasts more
            than 3 million monthly listeners, gave to the Italian duo the
            opportunity to remix their single 'Radio Love'. The remix reached a
            total of 3.5 million streams on Spotify.
          </p>
          <br />
          <p>
            In May 2019 they released 'A Place For Us' with the Austrian singer
            Ynnox, through Loudkult label. The song quickly reached over 10
            million streams on Spotify, entering into tons of iTunes charts and
            Spotify's Viral in different countries around the world.
          </p>
          <br />
          <p>
            The Italian duo had the opportunity to work with artists such as
            SEEB and Justin Jesso by releasing their remix of the song 'Bigger
            Than' on the SONY / COLUMBIA label.
          </p>
          <br />
          <div className="social__media__icons">
            <li>
              <a
                href="https://www.instagram.com/dualitiesmusic/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaInstagram fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://www.facebook.com/dualitiesmusic"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaFacebook fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a
                href="https://twitter.com/dualitiesmusic"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p>
                  <FaTwitter fill="white" size={40} />
                </p>
              </a>
            </li>
            <li>
              <a href="#" rel="noopener noreferrer">
                <p>
                  <FaSoundcloud fill="white" size={40} />
                </p>
              </a>
            </li>
          </div>
        </div>

        {/*Photos or Videos + playlist.*/}
        <div>
          <div className="__photos" data-aos="fade-up">
            <img src={DualitiesImage} className="artists__photo__size" />
          </div>
        </div>
      </div>

      <div className="spotify__playlist" data-aos="fade-right">
        <iframe
          src="https://open.spotify.com/embed/playlist/2nzTjF0uAogjSrmgvZ0PoR?utm_source=generator&theme=0"
          width="800"
          height="380"
          frameBorder="0"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
        ></iframe>
      </div>
    </div>
  );
}

export default Dualities;
